export const STATS_CHART_COLORS = {
  purple: "#786FF6",
  teal: "#63C7C4",
  coral: "#FF6A6A",
  yellow: "#FFDF34",
  ink: "#22211C"
} as const

export const STATS_CATEGORICAL_COLORS = [
  STATS_CHART_COLORS.purple,
  STATS_CHART_COLORS.teal,
  STATS_CHART_COLORS.coral,
  STATS_CHART_COLORS.yellow,
  STATS_CHART_COLORS.ink
]
